

/**
 * searchName_SearchShortName_Max_FieldLengths_Constants.ts
 *
 *    Keep in sync with Java class FieldLengthConstants
 */

export class SearchName_SearchShortName_Max_FieldLengths_Constants {

    static readonly SEARCH_NAME_MAX_LENGTH = 2000; // DB: 2000
    static readonly SEARCH_SHORT_NAME_MAX_LENGTH = 8; // DB: 50
}

